<template>
    <div
        class="loading-wrapper"
        :class="{ inline }"
    >
        <i class="icon-spinner icon-pulse"></i>
    </div>
</template>

<script>
export default {
    props: {
        inline: {
            type: Boolean,
            required: false,
            default: false,
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.loading-wrapper {
    text-align: center;
    width: 100%;
    font-size: 3em;
    &.inline {
        font-size: 1em;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 100px;
    }
}
</style>
